module.exports = __webpack_public_path__ + "static/img/login-box-left.22685418.svg";